import { Box, Text } from 'native-base';
import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';

// Orders older than this are flagged pink/red on the fulfilment tables.
const OVERDUE_MINUTES = 24 * 60;

// e.g. "9d 20h 13m", "3h 5m", "12m" — leading zero units are dropped.
export const formatOrderAge = (totalMinutes: number) => {
  const days = Math.floor(totalMinutes / (24 * 60));
  const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
  const minutes = totalMinutes % 60;

  if (days > 0) return `${days}d ${hours}h ${minutes}m`;
  if (hours > 0) return `${hours}h ${minutes}m`;
  return `${minutes}m`;
};

// Re-renders once a minute so the age keeps counting while the tab is open.
const useNow = () => {
  const [now, setNow] = useState(() => dayjs());

  useEffect(() => {
    const interval = setInterval(() => setNow(dayjs()), 60_000);
    return () => clearInterval(interval);
  }, []);

  return now;
};

export const OrderAge = ({ createdAt }: { createdAt: string | null | undefined }) => {
  const now = useNow();
  const created = createdAt ? dayjs(createdAt) : null;

  if (!created?.isValid()) return <Text color={'gray.400'}>-</Text>;

  const totalMinutes = Math.max(0, now.diff(created, 'minute'));
  const overdue = totalMinutes >= OVERDUE_MINUTES;

  return (
    <Box alignSelf={'flex-start'} bg={overdue ? 'red.100' : 'gray.100'} borderRadius={'full'} px={4} py={1}>
      <Text fontWeight={700} color={overdue ? 'red.600' : 'gray.700'}>
        {formatOrderAge(totalMinutes)}
      </Text>
    </Box>
  );
};
